import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getWithdrawalStatusCheckLive, getWithdrawalStatusCheckLiveUpdate } from "../services/withdrawalStatusCheckLiveServices";

const initialState = {
  items: {},
};

export const withdrawalStatusCheckLiveGet = createAsyncThunk(
  "/withdrawalStatusCheckLiveGet",
  async (payload) => {
    return await getWithdrawalStatusCheckLive(payload);
  }
);

export const withdrawalStatusCheckLiveGetUpdate = createAsyncThunk(
  "/withdrawalStatusCheckLiveUpdate",
  async (payload) => {
    return await getWithdrawalStatusCheckLiveUpdate(payload);
  }
);

const withdrawalStatusCheckLiveSlice = createSlice({
  name: "withdrawalStatusCheckLiveSlice",
  initialState,
  reducers: {
    clearWithdrawalStatusCheckLive: () => initialState,
    setPayoutBlock: (state, { payload }) => {
      state.items = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(withdrawalStatusCheckLiveGet.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  },
});
export default withdrawalStatusCheckLiveSlice.reducer;
export const { clearWithdrawalStatusCheckLive, setPayoutBlock } = withdrawalStatusCheckLiveSlice.actions;

export const selectWithdrawalStatusCheckLive = (state) => {
  return state.withdrawalStatusCheckLive.items;
};
export const useWithdrawalStatusCheckLive = () => {
  const items = useSelector(selectWithdrawalStatusCheckLive);
  return useMemo(() => items, [items]);
};
